import { render, staticRenderFns } from "./AudioGuideTrack.vue?vue&type=template&id=47b6a0c4&"
import script from "./AudioGuideTrack.vue?vue&type=script&lang=ts&"
export * from "./AudioGuideTrack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports